/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/12/2020
 */

import DatabaseSettingsItem from "@/utils/dataMigration/database/DatabaseSettingsItem";
import {
	Migration_0_1,
	Migration_10_11,
	Migration_11_12,
	Migration_12_13,
	Migration_13_14,
	Migration_14_15,
	Migration_15_16,
	Migration_16_17,
	Migration_17_18, Migration_18_19, Migration_19_20, Migration_20_21,
	Migration_21_22,
	Migration_22_23,
	Migration_23_24,
	Migration_24_25,
	Migration_1_2,
	Migration_2_3,
	Migration_3_4,
	Migration_4_5,
	Migration_5_6,
	Migration_6_7,
	Migration_7_8,
	Migration_8_9,
	Migration_9_10,
} from "@/utils/dataMigration/database/Migrations";
import BaseMigrationManager from "@/utils/dataMigration/BaseMigrationManager";
import Migration_25_26 from "@/utils/dataMigration/database/Migration_25_26";
import Migration_26_27 from "@/utils/dataMigration/database/Migration_26_27";


export default class DatabaseMigrationManager extends BaseMigrationManager {


	dataBaseSettings: DatabaseSettingsItem


	constructor(dataManager, authManager, analyticManager) {
		super(dataManager, authManager, analyticManager);
		this.addMigration(new Migration_0_1())
		this.addMigration(new Migration_1_2())
		this.addMigration(new Migration_2_3())
		this.addMigration(new Migration_3_4())
		this.addMigration(new Migration_4_5())
		this.addMigration(new Migration_5_6())
		this.addMigration(new Migration_6_7())
		this.addMigration(new Migration_7_8())
		this.addMigration(new Migration_8_9())
		this.addMigration(new Migration_9_10())
		this.addMigration(new Migration_10_11())
		this.addMigration(new Migration_11_12())
		this.addMigration(new Migration_12_13())
		this.addMigration(new Migration_13_14())
		this.addMigration(new Migration_14_15())
		this.addMigration(new Migration_15_16())
		this.addMigration(new Migration_16_17())
		this.addMigration(new Migration_17_18())
		this.addMigration(new Migration_18_19())
		this.addMigration(new Migration_19_20())
		this.addMigration(new Migration_20_21())
		this.addMigration(new Migration_21_22())
		this.addMigration(new Migration_22_23())
		this.addMigration(new Migration_23_24())
		this.addMigration(new Migration_24_25())
		this.addMigration(new Migration_25_26())
		this.addMigration(new Migration_26_27())
	}

	addMigration(migration){
		this.migrations.push(migration)
		return this
	}

	async needsUpgrade(){
		this.dataBaseSettings = await this.dataManager.getDatabaseSettings() || new DatabaseSettingsItem()
		let res = this.dataBaseSettings.dbVersion < DatabaseSettingsItem.CURRENT_DB_VERSION
		console.log("DatabaseMigrationManager.needsUpgrade: ", res, ", this.dataBaseSettings = ", this.dataBaseSettings, ", DatabaseSettingsItem.CURRENT_DB_VERSION = ", DatabaseSettingsItem.CURRENT_DB_VERSION)
		return res

	}

	async startUpgrade(progressCallback){
		let startVersion = this.dataBaseSettings.dbVersion
		let endVersion = DatabaseSettingsItem.CURRENT_DB_VERSION

		await super.startUpgrade(startVersion, endVersion, progressCallback)

		this.dataBaseSettings.dbVersion = endVersion
		await this.dataManager.setDatabaseSettings(this.dataBaseSettings)
	}
}
